import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";

// Wraps children in an element that fades/slides up when scrolled into view.
// `as` lets it render as any tag (e.g. "section") so existing CSS selectors keep working.
const Reveal = ({ as: Tag = "div", delay = 0, className = "", style, children, ...rest }) => {
  const [ref, visible] = useScrollReveal();

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "reveal-visible" : ""}${className ? ` ${className}` : ""}`}
      style={{ ...style, transitionDelay: delay ? `${delay}ms` : undefined }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
